module.exports = __webpack_public_path__ + "img/1203.86fec503.png";